import cloneDeep from 'lodash/cloneDeep';

import { get as apiGet } from 'Api';
import store from 'Redux/store';

const PRODUCTS_GROUP_AGGREGATE = 'frontend/product/PRODUCTS_GROUP_AGGREGATE';
const YT_VIDEO_BROKEN = 'frontend/products/YT_VIDEO_BROKEN';

const language = window.locale || 'en';

export function ytVideoBroken(video) {
  return store.dispatch({ type: YT_VIDEO_BROKEN, payload: video });
}


export function checkVideoData(src) {
  const url = `/products/video-check/${src}`;
  return apiGet(store.dispatch, url, true)
    .then(({ response, data }) => {
      if (response.status !== 200) {
        return 'failed to fetch';
      }
      return data.status;
    });
}

export function fetchProduct(slug) {
  const url = `/products-group/${slug}/${language}`;
  return apiGet(store.dispatch, url, true)
    .then(({ response, data }) => {
      if (response.status === 401) {
        return fetchProduct(slug);
      }

      if (response.status > 400) {
        return { product: null, notFound: true };
      }

      if (data && data.redirect) {
        return { redirect: `${data.redirect}${data.name ? `#bundle-ended-${encodeURIComponent(data.name)}` : ''}` };
      }

      const gtmFilteredProduct = cloneDeep(data);
      delete gtmFilteredProduct.blogPosts;
      delete gtmFilteredProduct.streams;
      delete gtmFilteredProduct.videos;
      delete gtmFilteredProduct.desc;
      delete gtmFilteredProduct.regions_excluded;
      delete gtmFilteredProduct.regions_included;
      delete gtmFilteredProduct.img;
      delete gtmFilteredProduct.reviews;
      delete gtmFilteredProduct.editions;
      delete gtmFilteredProduct.notice;

      store.dispatch({ type: PRODUCTS_GROUP_AGGREGATE, payload: gtmFilteredProduct });
      return { product: data };
    });
}

export function fetchProductPreview(id, key) {
  let url = `/admin/products/preview/${id}/${language}`;
  if (key) url = `/products/key-preview/${id}/${language}?key=${key}`;

  return apiGet(store.dispatch, url)
    .then(async ({ response, data }) => {
      if (response.status === 401) {
        alert('Log in as an admin to preview products'); // eslint-disable-line no-alert
      }

      if (response.status > 400) {
        return { product: null, notFound: true };
      }

      return { product: { ...data, isPreview: !!key } };
    });
}

export async function getSampleDownloadUrl(fileID) {
  const { response, data } = await apiGet(store.dispatch, `/products/download-sample/${fileID}`);

  if (response.ok) return data;
  throw Error(response.statusText);
}

export async function getFanFavourites({ hitsPerPage, onSale, newReleases }) {
  let recommendations = [];
  let url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&language=${language}`;

  if (onSale) {
    url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&onSale=true&excludeGiveaway=true&language=${language}`;
  }

  if (newReleases) {
    url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&language=${language}&newReleases=true`;
  }

  try {
    const { response, data } = await apiGet([], url);
    if (response.ok) recommendations = data;
  } catch (ex) { /* */ }

  return recommendations;
}

/**
 *  Retrieve user tags for a product
 * @type {String} productId
 * @return {Array} user tags
 */
export const getSuggestedTagsByProductId = async (productId) => {
  const { response, data } = await apiGet([], `/products/tags/get-suggested-by-product-id/${productId}/${language}`);
  if (response.ok) return data;

  throw new Error(data.message || response.status);
};
